import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import { CustomButton } from '../../components/Infra/CustomButton/CustomButton';
import { Configuration } from '../../components/DataFeed/Configuration/Configuration';
import Actions from '../../store/Actions';
import { useConfiguration } from '../../store/configurationStore';

export const DataFeedConfigurationPage = () => {
  const navigate = useNavigate();
  const [loadingHeaders, setLoadingHeaders] = useState(true);
  const { setAvailableHeaders } = useConfiguration();

  useEffect(() => {
    const fetchHeaders = async () => {
      setLoadingHeaders(true);
      const fetchedHeaders = await Actions.getDanelExcelHeaders();
      setAvailableHeaders(fetchedHeaders);
      setLoadingHeaders(false);
    };

    fetchHeaders();
  }, []);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2,
        }}
      >
        <PageHeader
          title="Transaction Type Configuration 2"
          subtitle="Configure field mappings and transformations for different instrument types"
        />
        <CustomButton variant="text" onClick={() => navigate('/danel')}>
          BACK TO DATA FEED
        </CustomButton>
      </Box>

      <Box sx={{ flex: 1, minHeight: 0 }}>
        <Configuration loading={loadingHeaders} />
      </Box>
    </Box>
  );
};
